import React from 'react';

const StarIcon = ({
	fill = '#F2C94C',
	width = 14,
	height = 14,
}: {
	width?: number;
	height?: number;
	fill?: string;
}) => {
	return (
		<svg
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
		>
			<path
				d="M6.55165 0.408345C6.73506 0.036761 7.26494 0.0367615 7.44835 0.408346L9.3175 4.19503L13.4981 4.80609C13.9081 4.86601 14.0715 5.36993 13.7747 5.65901L10.75 8.60503L11.4637 12.7663C11.5338 13.1748 11.105 13.4863 10.7382 13.2934L7 11.3275L3.26182 13.2934C2.895 13.4863 2.46623 13.1748 2.53629 12.7663L3.25 8.60503L0.225339 5.65901C-0.0714581 5.36993 0.0919344 4.86601 0.501892 4.80609L4.6825 4.19503L6.55165 0.408345Z"
				fill={fill}
			/>
		</svg>
	);
};

export default StarIcon;
